/* eslint-disable max-len */
import { SVGAttributes } from 'react';

export default ({ color = '#FFF', ...props }: SVGAttributes<SVGElement> & { color?: string }) => (
	<svg width="24px" viewBox="0 0 24 24" {...props}>
		<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
			<g transform="translate(5, 14)" fill={color}>
				<path d="M1,0 L1,4 L13,4 L13,0 L14,0 L14,4 C14,4.55228475 13.5522847,5 13,5 L1,5 C0.44771525,5 0,4.55228475 0,4 L0,0 L1,0 Z" />
			</g>
			<path
				d="M16.0580583,6.31694174 L16.0580583,13.3169417 L14.5577379,13.3169417 L14.5577379,8.85294174 L8.74739809,14.6647862 L7.68673792,13.6041261 L13.4727379,7.81694174 L9.05773792,7.81694174 L9.05805826,6.31694174 L16.0580583,6.31694174 Z"
				fill={color}
				transform="translate(11.8724, 10.4909) rotate(-45) translate(-11.8724, -10.4909)"
			/>
		</g>
	</svg>
);
